import Http from '@/api/http.js'

export default {

  index(params) {
    return Http.get(`/fiscal_notes`, {params: {...params}})
  },

  create(fiscal_note){
    return Http.post(`/fiscal_notes`, {fiscal_note: {...fiscal_note}})
  },

  update(fiscal_note){
    return Http.put(`/fiscal_notes/${fiscal_note.id}`, {
      fiscal_note: {...fiscal_note},
    });
  },

  show(id) {
    return Http.get(`/fiscal_notes/${id}`);
  },

  updateWithFormData(fiscal_note){
    return Http.put(`/fiscal_notes/${fiscal_note.get('fiscal_note[id]')}`, fiscal_note);
  },

}
